import React, {useState, useEffect} from 'react';
import './style.css';
import ContentHeading from '../../components/contentHeading/contentHeading';
import TableView from '../../components/tableView/tableView';
import { authFetch } from '../../components/authFetch/authFetch'
import { Throbber } from '../../components/throbber/throbber'
import { Link } from 'react-router-dom';

const Flows = () => {
    const [flows, setFlows] = useState([]);
    const [statusState, setStatusState] = useState('loading');

    const headings = {
        Flows: 'Flows',
        Type: 'Type',
        Status: 'Status',
        LastUpdated: 'Last Updated',
        OpenRate: 'Open Rate',
        ClickRate: 'Click Rate',
        Deliveries: 'Deliveries'
    };

    const formatCampaignData = (data) => {
        console.log(data)
        if (!data || !Array.isArray(data)) {
            console.error("formatCampaignData received invalid data:", data);
            return [];  // ✅ Return an empty array to prevent errors
        }

        return data.map((flow) => ({
            Flows: <Link to="/flows/flows-detail" style={{ color: "black"}}>{flow.name}</Link>,
            Type: "Email",
            Status: flow.status || "Unknown",
            LastUpdated: flow.last_updated 
                ? new Date(flow.last_updated).toLocaleDateString() 
                : "N/A",
            OpenRate: flow.open_rate !== undefined ? `${flow.open_rate * 100}%` : "N/A",
            ClickRate: flow.click_rate !== undefined ? `${flow.click_rate * 100}%` : "N/A",
            Deliveries: flow.deliveries !== undefined ? `${flow.deliveries}` : "N/A",
        }));
    };

    useEffect(() => {
        authFetch({
            apiMethod: "GET",
            endpoint: "/flow",
            onDataLoaded: (data) => {
                setStatusState("success")
                setFlows(formatCampaignData(data?.flows))
            },
            onErrorResponse: (data) => {
                setStatusState("error");
                console.log("error");
            }
        });
    }, []);

    return (
        <div className='flows-container'>

            {statusState == "loading" && (
                <div className="throbber-overlay">
                    <Throbber />
                </div>
            )}

            <ContentHeading heading="Flows" />
            <TableView data={flows} headings={headings}/>
        </div>
    );
}; 

export { Flows };
